import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import Icon from '@/atoms/Icon'
import Link from '@/atoms/Link'
import PRODUCT_AS_FANSI_KIND from '@/constants/productAsFansiKind'
import Product from '@/ts/Product'

import BestsellersBadge from './includes/BestsellerBadge'
import Body from './includes/Body'
import Features from './includes/Features'
import Header from './includes/Header'
import LowestPrice from './includes/LowestPrice'
import NewnessBadge from './includes/NewnessBadge'
import Quantity from './includes/Quantity'

function ShoppingCard({ product }: ShoppingCardProps) {
  const { t } = useTranslation('products')
  const kind = PRODUCT_AS_FANSI_KIND[product.type]

  return (
    <article className="flex justify-center flex-none px-6 py-8 border-2 shadow-xl xl:px-12 md:py-14 border-sbtviolet-100 rounded-xl">
      <div className="w-full max-w-md space-y-10">
        <div className="flex flex-row space-x-4">
          {product.newness && <NewnessBadge />}
          {product.bestseller && <BestsellersBadge />}
        </div>
        <Header product={product} kind={kind} />
        {product.type === 'Product::FansiCollection' && (
          <Quantity quantity={product?.sizes[0]?.quantity} />
        )}
        {product.price.price_before_discount > product.price.value && (
          <LowestPrice lowestPrice={product?.lowest_price_subunit} />
        )}
        <Body product={product} />
        <div>
          <Features kind={kind} />
          <Link href="/contact" className="flex items-center mt-4 space-x-4">
            <Icon
              className="w-[18px] flex-shrink-0 text-sbtviolet-550"
              name="send"
            />
            <span className="text-sm">{t('send')}</span>
          </Link>
        </div>
      </div>
    </article>
  )
}

interface ShoppingCardProps {
  product: Product
}

export default memo(ShoppingCard)
